var GALLERY_SIZE_TYPE = {
    SMART: 'smart',
    PIXELS: 'px',
    RATIO: 'ratio',
};
export default GALLERY_SIZE_TYPE;
//# sourceMappingURL=gallerySizeType.js.map